import { render, staticRenderFns } from "./CopyList.vue?vue&type=template&id=dc06dc34&scoped=true"
import script from "./CopyList.vue?vue&type=script&lang=js"
export * from "./CopyList.vue?vue&type=script&lang=js"
import style0 from "./CopyList.vue?vue&type=style&index=0&id=dc06dc34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc06dc34",
  null
  
)

export default component.exports